export const constructDoubleQuotedString = (s) => {
  let str = "\"";
  str = str.concat(s);
  str = str.concat("\"");
  return str;
}